export type MessageGroupMemberType = "workforce" | "user" | "contact" | "companyNumber";

export type MessageGroupChannel = "internal" | "sms";

export const GROUP_MMS_MAX_EXTERNAL_PARTICIPANTS = 9;

export interface GroupNumberValidation {
  input: string;
  phoneNumber: string | null;
  isValid: boolean;
  canJoinGroup: boolean;
  isFlownectNumber: boolean;
  flownectCompanyId: number | null;
  lineType: string | null;
  carrierName: string | null;
  contactName: string | null;
  warning: string | null;
  reason: string | null;
}

export type MessageGroupSystemEvent =
  | "groupCreated"
  | "membersAdded"
  | "memberRemoved"
  | "memberLeft"
  | "renamed"
  | "avatarChanged";

export interface MessageGroupMention {
  type: MessageGroupMemberType;
  uid: string;
  name: string;
  start: number;
  length: number;
}

export interface MessageGroupMember {
  type: MessageGroupMemberType;
  uid: string;
  firstName: string;
  lastName: string;
  avatar: string | null;
  role: string | null;
  roleName: string | null;
  isAdmin: boolean;
  phoneNumber?: string | null;
}

export interface MessageGroupSummary {
  groupUid: string;
  companyId: number;
  name: string;
  avatar: string | null;
  description: string | null;
  channel: MessageGroupChannel;
  smsFromNumber: string | null;
  conversationSid: string | null;
  createdByType: string;
  createdByUid: string;
  members: MessageGroupMember[];
  membersCount: number;
  isAdmin: boolean;
  lastMessage: string | null;
  lastMessageAt: string | null;
  lastMessageSenderName: string | null;
  messagesCount: number;
  unreadCount: number;
  lastReadAt: string | null;
  mentionsMe: boolean;
  createdAt: string;
}

export interface MessageGroupMemberInput {
  type: MessageGroupMemberType;
  uid: string;
  isAdmin?: boolean;
  phoneNumber?: string;
  displayName?: string;
}
